



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
import LayoutSwitchMap from '@/views/switchMap/LayoutSwitchMap.vue';
import LayoutToolBar from '@/views/toolbar/LayoutToolBar.vue';
import LayoutSearch from '@/views/search/LayoutSearch.vue';
import SearchTipPanel from '@/views/search/SearchTipPanel.vue';
import SearchResult from '@/views/search/SearchResult.vue';
import MessageDetails from '@/views/search/MessageDetails.vue';
import LayoutPathPlan from '@/views/pathPlan/LayoutPathPlan.vue';

@Component({
  name: 'LayoutComposite',
  components: {
    LayoutSwitchMap,
    LayoutToolBar,
    LayoutSearch,
    SearchTipPanel,
    SearchResult,
    MessageDetails,
    LayoutPathPlan,
  },
})
export default class LayoutComposite extends Vue {
  @Injectable() public container!: Container;
  private showPathPanel: any = false;
  private showFlightLinePanel: any = false;
  private twoToThreeMapButton: any = false;

  private tipPanelDatas: any = null; // 关键词面板数据
  private searchResultDatas: any = {}; // 搜索结果数据
  private messageDetailData: any = {}; // 附近信息面板的数据

  constructor() {
    super();
  }

  // 获取关键词面板数据
  private getTipPanelDatas(val: any) {
    this.tipPanelDatas = val;
    this.$store.dispatch('searchStore/isShowTipPanelEmit', true);
  }
  // 获取搜索后的数据
  private searchResultDatasEmit(val: any) {
    this.searchResultDatas = val;
    this.$store.dispatch('searchStore/isShowSearchResultEmit', true);
  }
  // 获取附近信息面板的数据
  private messageDetailDataEmit(val: any) {
    this.messageDetailData = val;
    this.$store.dispatch('searchStore/isShowMessageDetailEmit', true);
  }

  private showPathPanelEmit() {
    this.showPathPanel = true;
  }
  private closePathPanelEmit() {
    this.showPathPanel = false;
  }
  private flightButtonClick() {
    this.showFlightLinePanel = !this.showFlightLinePanel;
  }

  private initMapEvents() {
    // 二三维切换，全局通知
    const notify = this.container.resolve('notify');
    notify.on(
      'dimension-changed',
      (d: any) => {
        if (d === '2d') {
          this.twoToThreeMapButton = false;
          this.showFlightLinePanel = false;
        } else {
          this.twoToThreeMapButton = true;
        }
      }, this);
  }

  private created() {
    // this.initMapEvents();
  }

  private mounted() {}
}
